module.exports = __webpack_public_path__ + "img/logo.aa095b82.svg";